import React from 'react'
import DefaultDataTable from '../../../../components/default/DefaultDataTable'
import { MonthlyClosureDetailDataForm, MonthlyClosureDetailFilters, MonthlyClosureDetailWorkerDataForm } from '../../../../app/models/MonthlyClosureDetail';
import { DefaultDParams } from '../../../../app/shared/interfaces';
import MonthlyClosureDetailWorkerStatusChange from '../MonthlyClosureDetailWorkerStatusChange';
import MonthlyClosureDetailWorkerFilter from './MonthlyClosureDetailWorkerFilter';

interface Props {
    monthlyClosureDetailWorkers: MonthlyClosureDetailWorkerDataForm[];
    totalRows: number;
    loading?: boolean;
    filter: MonthlyClosureDetailFilters;
    setFilter: (filter: MonthlyClosureDetailFilters) => void;
    statuses: DefaultDParams[];
    callbackSuccess?: () => void;
    onSearch: () => void;
}


const MonthlyClosureDetailWorkerDataTable = ({
    monthlyClosureDetailWorkers,
    totalRows,
    loading,
    filter,
    setFilter,
    statuses,
    onSearch,
    callbackSuccess,
}: Props) => {

    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: MonthlyClosureDetailWorkerDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Conductor',
            selector: (row: any) => row.worker,
            sortable: true,
            sortField: 'worker',
            cell: (row: MonthlyClosureDetailWorkerDataForm, index: any, column: any) => <span className="">{row.worker}</span>
        },
        {
            name: 'Estado',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            cell: (row: MonthlyClosureDetailDataForm, index: any, column: any) => (
                (
                    <MonthlyClosureDetailWorkerStatusChange
                        detail={row} 
                        statuses={row.statuses!} 
                        callbackSuccess={callbackSuccess}
                    />
                )
           
            )
        }
    ]
    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <MonthlyClosureDetailWorkerFilter
                        filter={filter} 
                        setFilter={setFilter} 
                        onSearch={onSearch}
                    />
                </div>
            </div>
            <DefaultDataTable
                columns={columns}
                data={monthlyClosureDetailWorkers}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    )
}

export default MonthlyClosureDetailWorkerDataTable
